import { render } from "./AppFooter.vue?vue&type=template&id=706a6cac"
const script = {}

import "./AppFooter.vue?vue&type=style&index=0&id=706a6cac&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__